import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import People from "@material-ui/icons/People";
import { Grid, Typography } from "@material-ui/core";

import { withToggleModal } from "altus-ui-components";

import {
  getAvailablePersonnelOnshoreByCountry,
  getPersonnelOnshoreWithRequiredTimeoffByCountry,
} from "features/planner/report/report.actions";

import { APP_ROLES } from "app/app.constants";
import { DASHBOARD_EMPLOYEES_MODAL } from "features/planner/planner.constants";
import DashboardTile from "features/planner/report/dashboard/components/DashboardTile";

class PersonnelAvailableDashboardSection extends PureComponent {
  toggleModal = () => {
    const { dispatchToggleModal } = this.props;

    dispatchToggleModal({
      modalId: DASHBOARD_EMPLOYEES_MODAL,
    });
  };

  getPersonnelOnshoreWithRequiredTimeoffByCountryThenToggleModal = ({
    title,
    countryTwoLetterCode,
  }) => {
    const {
      setModalTitle,
      dispatchGetPersonnelOnshoreWithRequiredTimeoffByCountry,
    } = this.props;

    return dispatchGetPersonnelOnshoreWithRequiredTimeoffByCountry(
      countryTwoLetterCode,
    )
      .then(() => setModalTitle(title))
      .then(this.toggleModal);
  };

  getAvailablePersonnelOnshoreByCountry = ({ title, countryTwoLetterCode }) => {
    const {
      setModalTitle,
      dispatchGetAvailablePersonnelOnshoreByCountry,
    } = this.props;

    return dispatchGetAvailablePersonnelOnshoreByCountry(countryTwoLetterCode)
      .then(() => setModalTitle(title))
      .then(this.toggleModal);
  };

  render() {
    const { stats } = this.props;

    return (
      <Grid container spacing={1}>
        <Grid container item>
          <Typography variant="h6">Altus personnel onshore</Typography>
        </Grid>
        <Grid container item spacing={2}>
          <Grid item xs={6} xl={3}>
            <DashboardTile
              chipLabel={stats.getIn([
                "personnelWithRequiredTimeoffByCountry",
                "no",
              ])}
              ActionButtonProps={{
                title: "Show employees",
                onClick: () =>
                  this.getPersonnelOnshoreWithRequiredTimeoffByCountryThenToggleModal(
                    {
                      countryTwoLetterCode: "no",
                      title: "Personnel with timeoff - Norway",
                    },
                  ),
                renderIcon: () => <People />,
                accessLevel: [APP_ROLES.ADMIN, APP_ROLES.PLANNER],
              }}
            >
              <Typography variant="body2" align="center">
                Personnel with timeoff <br /> <b>Norway</b>
              </Typography>
            </DashboardTile>
          </Grid>
          <Grid item xs={6} xl={3}>
            <DashboardTile
              chipLabel={stats.getIn([
                "personnelWithRequiredTimeoffByCountry",
                "dk",
              ])}
              ActionButtonProps={{
                title: "Show employees",
                onClick: () =>
                  this.getPersonnelOnshoreWithRequiredTimeoffByCountryThenToggleModal(
                    {
                      countryTwoLetterCode: "dk",
                      title: "Personnel with timeoff - Denmark",
                    },
                  ),
                renderIcon: () => <People />,
                accessLevel: [APP_ROLES.ADMIN, APP_ROLES.PLANNER],
              }}
            >
              <Typography variant="body2" align="center">
                Personnel with timeoff <br /> <b>Denmark</b>
              </Typography>
            </DashboardTile>
          </Grid>
          <Grid item xs={6} xl={3}>
            <DashboardTile
              chipLabel={stats.getIn(["availablePersonnelByCountry", "no"])}
              ActionButtonProps={{
                title: "Show employees",
                onClick: () =>
                  this.getAvailablePersonnelOnshoreByCountry({
                    countryTwoLetterCode: "no",
                    title: "Available personnel - Norway",
                  }),
                renderIcon: () => <People />,
                accessLevel: [APP_ROLES.ADMIN, APP_ROLES.PLANNER],
              }}
            >
              <Typography variant="body2" align="center">
                Available personnel <br /> <b>Norway</b>
              </Typography>
            </DashboardTile>
          </Grid>
          <Grid item xs={6} xl={3}>
            <DashboardTile
              chipLabel={stats.getIn(["availablePersonnelByCountry", "dk"])}
              ActionButtonProps={{
                title: "Show employees",
                onClick: () =>
                  this.getAvailablePersonnelOnshoreByCountry({
                    countryTwoLetterCode: "dk",
                    title: "Available personnel - Denmark",
                  }),
                renderIcon: () => <People />,
                accessLevel: [APP_ROLES.ADMIN, APP_ROLES.PLANNER],
              }}
            >
              <Typography variant="body2" align="center">
                Available personnel <br /> <b>Denmark</b>
              </Typography>
            </DashboardTile>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default compose(
  connect(null, {
    dispatchGetAvailablePersonnelOnshoreByCountry: getAvailablePersonnelOnshoreByCountry,
    dispatchGetPersonnelOnshoreWithRequiredTimeoffByCountry: getPersonnelOnshoreWithRequiredTimeoffByCountry,
  }),
  withToggleModal,
)(PersonnelAvailableDashboardSection);
